import React, { useState } from 'react';
import { UserDetails } from './UserDetails';
import { PersonalDetails } from './PersonalDetails';
import validator from 'validator';
import { VALIDATION_PASSWORD_REGEX } from '../settings/ChangePassword';

const Register = () => {
  const [values, setValues] = useState({
    step: 1,
    email: '',
    isValidEmail: true,
    password: '',
    isValidPassword: true,
    confirmPassword: '',
    isValidPasswordAgain: true,
    nickname: '',
    birthYear: '',
    province: '',
    phoneNumber: '',
    language: 'ENGLISH',
  });

  const prevStep = () => {
    setValues((prevValues) => ({ ...prevValues, step: prevValues.step - 1 }));
  };

  const nextStep = () => {
    setValues((prevValues) => ({ ...prevValues, step: prevValues.step + 1 }));
  };

  const validatePassword = (val, username) => {
    const isValid =
      val.length === 0 ||
      (VALIDATION_PASSWORD_REGEX.test(val) &&
        (username.length === 0 || !val.toLowerCase().includes(username.toLowerCase())));

    setValues((prevValues) => ({ ...prevValues, isValidPassword: isValid }));
  };

  const handleChange = (input, inputRef) => (e) => {
    const val = input === 'phoneNumber' ? e : e?.target.value || '';

    switch (input) {
      case 'email':
        const isValidEmail = val.length === 0 || validator.isEmail(val);
        validatePassword(values.password, val);
        setValues((prevValues) => ({
          ...prevValues,
          email: val,
          isValidEmail,
        }));
        break;
      case 'password':
        validatePassword(val, values.email);
        const isValidPassword =
          values.confirmPassword.length === 0 || val === values.confirmPassword;
        setValues((prevValues) => ({
          ...prevValues,
          password: val,
          isValidPasswordAgain: isValidPassword,
        }));
        break;
      case 'confirmPassword':
        const isValidPasswordAgain = val.length === 0 || val === values.password;
        setValues((prevValues) => ({
          ...prevValues,
          confirmPassword: val,
          isValidPasswordAgain: isValidPasswordAgain,
        }));
        break;
      default:
        setValues((prevValues) => ({ ...prevValues, [input]: val || '' }));
        break;
    }

    if (inputRef) {
      inputRef.current.focus();
    }
  };

  switch (values.step) {
    case 1:
      return <UserDetails nextStep={nextStep} handleChange={handleChange} values={values} />;
    case 2:
      return <PersonalDetails prevStep={prevStep} handleChange={handleChange} values={values} />;
    default:
      return null;
  }
};

export default Register;
